import { render, staticRenderFns } from "./ArticleItem.vue?vue&type=template&id=46151c64&"
import script from "./ArticleItem.vue?vue&type=script&lang=js&"
export * from "./ArticleItem.vue?vue&type=script&lang=js&"
import style0 from "./ArticleItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArticleItem.vue"
export default component.exports